
import * as ipxRuntime$mlby3__45L1P96doU_a1PCJkctjAz9HRjre01hYmH8T3M from '/service/node_modules/@nuxt/image/dist/runtime/providers/ipx'

export const imageOptions = {
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "ipx",
  "domains": [],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ]
}

imageOptions.providers = {
  ['ipx']: { provider: ipxRuntime$mlby3__45L1P96doU_a1PCJkctjAz9HRjre01hYmH8T3M, defaults: {} }
}
        